<div class="qualifications-tab">
  <div class="form-section">
    <div class="form-horizontal">
      <div class="form-row textarea-row">
        <label>Location-Specific Training</label>
        <textarea
          class="form-control"
          rows="5"
          [(ngModel)]="location.locationSpecificTraining"
          (ngModelChange)="onFieldChange()"
          [disabled]="!isEditMode"
          placeholder="Enter location-specific training notes..."
        ></textarea>
      </div>
    </div>
  </div>

  <div class="form-section">
    <h3 class="section-title">Product Qualifications</h3>
    <div *ngIf="allProductQualifications.length > 0" class="products-grid">
      <div
        *ngFor="
          let productQualification of allProductQualifications;
          trackBy: trackByProductQualificationId
        "
        class="product-item"
      >
        <span class="product-label">{{ productQualification.name }}</span>
        <div class="product-selector">
          <button
            type="button"
            class="product-badge"
            [ngClass]="{
              'product-yes': isProductQualificationSelected(productQualification.id),
              'product-no': !isProductQualificationSelected(productQualification.id),
              disabled: !isEditMode,
            }"
            (click)="isEditMode && toggleProductQualification(productQualification)"
            [disabled]="!isEditMode"
          >
            <i
              class="fa"
              [ngClass]="{
                'fa-check': isProductQualificationSelected(productQualification.id),
                'fa-times': !isProductQualificationSelected(productQualification.id),
              }"
            ></i>
            {{ isProductQualificationSelected(productQualification.id) ? "Yes" : "No" }}
          </button>
        </div>
      </div>
    </div>
    <p
      *ngIf="allProductQualifications.length === 0 && !loadingProductQualifications"
      class="placeholder-text"
    >
      No product qualifications available
    </p>
    <p *ngIf="loadingProductQualifications" class="placeholder-text">
      Loading product qualifications...
    </p>
  </div>
</div>
